// extracted by mini-css-extract-plugin
export default {"anomalyIcon":"explain_anomalyIcon__rjc6I","divider":"explain_divider__7gALk","tabButton":"explain_tabButton__vEiRg","tabButtonActive":"explain_tabButtonActive__C3-hO"};